// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
}

.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content {
    margin: 0;
    align-items: center;
}

.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-root {
    padding: 16px;
}

/* .baloa-pro-manage-subscription-widget__accordion .MuiButtonBase-root.MuiAccordionSummary-root {
    padding: 0;
    padding-bottom: 16px;
} */

.baloa-pro-manage-subscription-widget__accordion.MuiPaper-root.MuiAccordion-root {
    box-shadow: none;
    border: 1px solid var( --new-gray-background-color);
    border-radius: 8px;
}

.baloa-pro-manage-subscription-widget__accordion .MuiCollapse-wrapper {
    width: unset;
    margin: 0 16px;
    border-top: 1px solid var( --new-gray-background-color);
}

.baloa-pro-manage-subscription-widget__accordion .MuiAccordionDetails-root {
    padding: 14px 0;
}

.baloa-pro-manage-subscription-widget__title {
    display: flex;
    align-items: center;
}

.baloa-pro-manage-subscription-widget__title .baloa-subtitle-1 {
    font-weight: var(--font-bold);
    font-family: "Lexend Deca";
}

.baloa-pro-manage-subscription-widget__title .hubicon-award_star {
    font-size: 40px;
}

.baloa-pro-manage-subscription-widget__subtitle {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.baloa-pro-manage-subscription-widget__subtitle-name {
    color: var(--primary-dark-color);
    font-family: "Lexend Deca";
    font-size: 18px;
    font-style: normal;
    font-weight: var(--font-regular);
    line-height: normal;
    letter-spacing: 0.027px;
}

.baloa-pro-manage-subscription-widget__subtitle-value {
    color: var(--primary-dark-color);
    font-family: "Lexend Deca";
    font-size: 18px;
    font-style: normal;
    font-weight: var(--font-bold);
    line-height: normal;
    letter-spacing: 0.027px;
}

.baloa-pro-manage-subscription-widget__title-acction {
    position: absolute;
    right: 40px;
    color: var(--new-primary-dark-color);
    font-family: "Lexend Deca";
    font-size: 18px;
    font-style: normal;
    font-weight: var(--font-medium);
    line-height: normal;
    letter-spacing: 0.045px;
}

.baloa-pro-manage-subscription-widget__payment-item {
    position: relative;
    margin-top: 36px;
}

.baloa-pro-manage-subscription-widget__payment-item:first-child {
    margin-top: 0;
}

.baloa-pro-manage-subscription-widget__payment-subtitle.baloa-normal-medium {
    font-family: "Lexend Deca";
    color: var(--primary-very-dark-color);
}

.baloa-pro-manage-subscription-widget__payment-option {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 12px;
    gap: 4px;
}

.baloa-pro-manage-subscription-widget__payment-method-name.baloa-normal {
    font-family: "Lexend Deca";
    color: var(--primary-dark-color);
}

.baloa-pro-manage-subscription-widget__payment-method-number.baloa-normal-medium {
    font-family: "Lexend Deca";
    color: var(--primary-dark-color);
}

.baloa-pro-manage-subscription-widget__payment-item__option {
    position: absolute;
    top: 20px;
    right: 0;
    color: var(--new-green-color);
    font-family: "Lexend Deca";
    font-size: calc(var(--space-half-quarter) + var(--space-quarter) + var(--space-eighth));/* 18px */
    font-style: normal;
    font-weight: var(--font-medium);
    line-height: normal;
    letter-spacing: 0.045px;
    cursor: pointer;
}

.baloa-pro-manage-subscription-widget__payment-item__option.cancel {
    color: var(--error-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .baloa-pro-manage-subscription-widget__accordion .MuiCollapse-wrapper {
        border-top: none;
    }

    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-root {
        justify-content: flex-start;
    }

    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-expandIconWrapper {
        align-self: flex-end;
    }
    .baloa-pro-manage-subscription-widget__title .hubicon-award_star {
        font-size: 22px;
    }
    .baloa-pro-manage-subscription-widget__title-acction {
        position: relative;
        right: unset;
        font-size: 16px;
        margin-top: 16px;
    }

    .baloa-pro-manage-subscription-widget__subtitle-name, 
    .baloa-pro-manage-subscription-widget__subtitle-value {
        font-size: 16px;
    }

    .baloa-pro-manage-subscription-widget__payment-item__option {
        position: relative;
        top: unset;
        margin-top: 12px;
    }

    .baloa-pro-manage-subscription-widget__payment-item {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid var( --new-gray-background-color);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-manage-subscription-widget/BaloaProManageSubscriptionWidgetComponent.styles.css"],"names":[],"mappings":";AACA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;GAGG;;AAEH;IACI,gBAAgB;IAChB,mDAAmD;IACnD,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,uDAAuD;AAC3D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,6BAA6B;IAC7B,0BAA0B;IAC1B,uFAAuF,CAAC,SAAS;IACjG,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,uDAAuD;IAC3D;AACJ","sourcesContent":["\n.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content.Mui-expanded {\n    margin: 0;\n}\n\n.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content {\n    margin: 0;\n    align-items: center;\n}\n\n.baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-root {\n    padding: 16px;\n}\n\n/* .baloa-pro-manage-subscription-widget__accordion .MuiButtonBase-root.MuiAccordionSummary-root {\n    padding: 0;\n    padding-bottom: 16px;\n} */\n\n.baloa-pro-manage-subscription-widget__accordion.MuiPaper-root.MuiAccordion-root {\n    box-shadow: none;\n    border: 1px solid var( --new-gray-background-color);\n    border-radius: 8px;\n}\n\n.baloa-pro-manage-subscription-widget__accordion .MuiCollapse-wrapper {\n    width: unset;\n    margin: 0 16px;\n    border-top: 1px solid var( --new-gray-background-color);\n}\n\n.baloa-pro-manage-subscription-widget__accordion .MuiAccordionDetails-root {\n    padding: 14px 0;\n}\n\n.baloa-pro-manage-subscription-widget__title {\n    display: flex;\n    align-items: center;\n}\n\n.baloa-pro-manage-subscription-widget__title .baloa-subtitle-1 {\n    font-weight: var(--font-bold);\n    font-family: \"Lexend Deca\";\n}\n\n.baloa-pro-manage-subscription-widget__title .hubicon-award_star {\n    font-size: 40px;\n}\n\n.baloa-pro-manage-subscription-widget__subtitle {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n}\n\n.baloa-pro-manage-subscription-widget__subtitle-name {\n    color: var(--primary-dark-color);\n    font-family: \"Lexend Deca\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: var(--font-regular);\n    line-height: normal;\n    letter-spacing: 0.027px;\n}\n\n.baloa-pro-manage-subscription-widget__subtitle-value {\n    color: var(--primary-dark-color);\n    font-family: \"Lexend Deca\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: var(--font-bold);\n    line-height: normal;\n    letter-spacing: 0.027px;\n}\n\n.baloa-pro-manage-subscription-widget__title-acction {\n    position: absolute;\n    right: 40px;\n    color: var(--new-primary-dark-color);\n    font-family: \"Lexend Deca\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: var(--font-medium);\n    line-height: normal;\n    letter-spacing: 0.045px;\n}\n\n.baloa-pro-manage-subscription-widget__payment-item {\n    position: relative;\n    margin-top: 36px;\n}\n\n.baloa-pro-manage-subscription-widget__payment-item:first-child {\n    margin-top: 0;\n}\n\n.baloa-pro-manage-subscription-widget__payment-subtitle.baloa-normal-medium {\n    font-family: \"Lexend Deca\";\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro-manage-subscription-widget__payment-option {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 12px;\n    gap: 4px;\n}\n\n.baloa-pro-manage-subscription-widget__payment-method-name.baloa-normal {\n    font-family: \"Lexend Deca\";\n    color: var(--primary-dark-color);\n}\n\n.baloa-pro-manage-subscription-widget__payment-method-number.baloa-normal-medium {\n    font-family: \"Lexend Deca\";\n    color: var(--primary-dark-color);\n}\n\n.baloa-pro-manage-subscription-widget__payment-item__option {\n    position: absolute;\n    top: 20px;\n    right: 0;\n    color: var(--new-green-color);\n    font-family: \"Lexend Deca\";\n    font-size: calc(var(--space-half-quarter) + var(--space-quarter) + var(--space-eighth));/* 18px */\n    font-style: normal;\n    font-weight: var(--font-medium);\n    line-height: normal;\n    letter-spacing: 0.045px;\n    cursor: pointer;\n}\n\n.baloa-pro-manage-subscription-widget__payment-item__option.cancel {\n    color: var(--error-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .baloa-pro-manage-subscription-widget__accordion .MuiCollapse-wrapper {\n        border-top: none;\n    }\n\n    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-content {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-root {\n        justify-content: flex-start;\n    }\n\n    .baloa-pro-manage-subscription-widget__accordion .MuiAccordionSummary-expandIconWrapper {\n        align-self: flex-end;\n    }\n    .baloa-pro-manage-subscription-widget__title .hubicon-award_star {\n        font-size: 22px;\n    }\n    .baloa-pro-manage-subscription-widget__title-acction {\n        position: relative;\n        right: unset;\n        font-size: 16px;\n        margin-top: 16px;\n    }\n\n    .baloa-pro-manage-subscription-widget__subtitle-name, \n    .baloa-pro-manage-subscription-widget__subtitle-value {\n        font-size: 16px;\n    }\n\n    .baloa-pro-manage-subscription-widget__payment-item__option {\n        position: relative;\n        top: unset;\n        margin-top: 12px;\n    }\n\n    .baloa-pro-manage-subscription-widget__payment-item {\n        margin-top: 12px;\n        padding-top: 12px;\n        border-top: 1px solid var( --new-gray-background-color);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
